export { default } from './VendorRequestsTable';
